<template>
    <div class="left-nav-box">
        <div class="title">ブレンド茶<br />顧客管理システム</div>
        <div v-for="menu in menus" @click="menu_chg(menu.address)" :class="current_menu(menu.status)" :key="menu.status" class="button">{{ menu.name }}</div>
        <div @click="logout()" class="button logout-button">ログアウト</div>
    </div>
</template>

<script>

// import axios from '@/axios';
// import Lib from '@/lib/';

export default {
  // ===========================================================================
  // props
  // ===========================================================================
  props: {
    status: 0,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      menus: [
        {name: '注文一覧', address: 'main', status: 1},
        {name: '会員一覧', address: 'customer_list', status: 2},
        {name: 'メール送信履歴', address: 'send_mail_history', status: 3},
        {name: 'ダウンロード', address: 'download', status: 4},
      ],
    };
  },
  computed: {
  },
  methods: {
    current_menu (status) {
      return this.status === status ? 'current_menu' : false;
    },
    menu_chg (address) {
      this.$router.push({path: '/manage/' + address});
    },
    logout () {
      this.$store.commit('mLoginInfo/logout', null);
      location.href = `${this.$DF.BASE_URL}manage?type=logout`;
    }
  },
};
</script>

<style lang="scss">
.left-nav-box {
    width: 250px;
    min-width: 160px;
    height: 100vh;
    background-color: #f4f4e5;
    .title {
      font-size: 1.1rem;
      white-space: nowrap;
      padding: 5px 0;
      color: #FFF;
      font-weight: bold;
      background-color: #738f53;
    }
    .button {
      padding: 8px 15px;
      font-weight: bold;
      background-color: transparent;
      border-bottom: 1px solid #deddc8;
      cursor: pointer;
      text-align: right;
    }
    .button:not(.current_menu):hover {
      background-color: #f3efab;
    }
    .current_menu {
      background-color: #ffffff;
    }
    .logout-button {
      margin-top: 40px;
      color: #7a1812;
      font-size: 0.9rem;
      border-top: 1px solid #deddc8;
    }
}
</style>
